"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-arrow-right-16><path d="M14.92 8.38a1 1 0 0 0-.22-1.09l-6-6a1 1 0 1 0-1.41 1.42L11.59 7H2a1 1 0 1 0 0 2h9.59l-4.3 4.29A1 1 0 1 0 8.7 14.7l6-6a1 1 0 0 0 .22-.32Z"></path></symbol>';
}
